module.exports = __webpack_public_path__ + "img/growth.cd189ee7.svg";